import './styles/index.scss';
import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { LicenseManager } from 'ag-grid-enterprise';

import Dashboard from './screens/dashboard/dashboard';
import AccountSettings from './components/account-settings/account-settings';
import Commuting from 'screens/commuting/commuting';
import PayrollRegister from './screens/payroll-register/payroll-register';
import BusinessEstablishmentSettings from './screens/businessEstablishmentSettings/businessEstablishmentSettings';
import SalarySpecification from './screens/salary_specification/salarySpecification';
import { Help } from './screens/help/Help';
import Payment from 'screens/payment/payment';
import PaymentInfo from 'screens/payment/payment-info/payment-info';
import BusinessEstablishmentChoice from './screens/businessEstablishmentChoice/business-establishment-choice';
import WorkingTemplate from './screens/workingTemplate/workingTemplate';
import AddWorkingTemplate from './screens/addWorkingTemplate/addWorkingTemplate';
import WorkContractModification from './screens/workContractModification/workContractModification';
import CheckList from 'screens/checklist/checklist';
import ChecklistForm from 'screens/checklist/checklist-form/checklist-form';
import ChecklistItem from 'screens/checklist/checklist-item/checklist-item';
import ViewInformation from './screens/viewInformation/viewInformation';
import WorkSchedule from './screens/workSchedule/WorkSchedule';
import CalendarAddEvent from './components/calendar/add-event/calendar-add-event';
import StaffRegistration from './screens/staff-registration/staff-registration';
import Calendar from './components/calendar/calendar';
import ScheduleModification from './screens/scheduleModification/ScheduleModification';
import AnnualLeaveModification from './screens/annualLeaveModification/annualLeaveModification';
import RecoveryContract from './screens/recoveryContractModification/recoveryContractModification';
import ScheduleTemplate from './screens/scheduleTemplate/scheduleTemplate';
import AddScheduleTemplate from './screens/addScheduleTemplate/addScheduleTemplate';
import EmployeeRegistration from './screens/employee-registration/employee-registration';
import RegisterCard from './components/employee-registration/register-card/register-card';
import BulkRegistration from './components/employee-registration/bulk-registration/bulk-registration';
import MonthlyView from './screens/calendarNote/calendarNote';
import WorkADiary from './components/work-a-diary/work-a-diary';
import AddNewDiary from './components/work-a-diary/add-new-diary/add-new-diary';
import BatchApplicationOfLaborTemplates from './screens/batch-application-of-labor-templates/BatchApplicationOfLaborTemplates';
import EmployeeListForSalarySpecification from './screens/salary_specification/employee-list-for-payroll/employee-list-for-payroll';
import TransferOfMgt from './screens/salary_specification/transfer-of-mgt/transfer-of-mgt';
import DetailPay from './screens/salary_specification/detail/DetailPay';
import AuthForDetailPay from './screens/salary_specification/authForDetailPay/AuthForDetailPay';
import ListOfEmployees from './screens/listOfEmployees/ListOfEmployees';
import AddWorkScheduleTemplate from './screens/addScheduleTemplate/addScheduleTemplate';
import ErrorBoundary from './components/ErrorBoundary';
import Login from 'screens/login/Login';
import AlertConfirm from './common/AlertConfirm';
import FetchLoading from './common/FetchLoading';
import '@progress/kendo-theme-default/dist/all.css';
import StatusChecker from './components/StatusChecker';

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_ENTERPRICE_KEY!);

const Wrap = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #f5f5f5;
`;

function App() {
  return (
    <Wrap>
      <StatusChecker />
      <ErrorBoundary>
        <Routes>
          {/* 로그인 */}
          <Route path="/login" element={<Login />} />
          {/* 1 Business Establishment Routes */}
          <Route path="/business-establishment-choice" element={<BusinessEstablishmentChoice />} />
          <Route
            path="/business-establishment-choice-update"
            element={<BusinessEstablishmentSettings type={'update'} />}
          />

          {/* 2. Dashboard */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />

          {/* 4. Account Settings */}
          <Route path="/account-settings" element={<AccountSettings />} />

          {/* 5. Help */}
          <Route path="/help" element={<Help />} />

          {/* 6. Select Payment Plan */}
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment-info" element={<PaymentInfo />} />

          {/* 7. Business Establishment Setting */}
          <Route path="/business-establishment-setting" element={<BusinessEstablishmentSettings type={'create'} />} />

          {/* 8. Employee Invitation */}
          <Route path="/employee-registration" element={<EmployeeRegistration />} />
          <Route path="/register-employee-card" element={<RegisterCard />} />
          <Route path="/bulk-registration" element={<BulkRegistration />} />

          {/* 9. Staff Registration */}
          <Route path="/staff-registration" element={<StaffRegistration />} />
          <Route path="/add-schedule-template" element={<AddWorkScheduleTemplate />}></Route>

          {/* 10. Working Template */}
          <Route path="/working-template" element={<WorkingTemplate />} />
          <Route path="/add-working-template" element={<AddWorkingTemplate />} />
          <Route path="/edit-working-template" element={<AddWorkingTemplate type="edit" />} />

          {/* 11. Staff List */}
          <Route path="/list-of-employees" element={<ListOfEmployees />} />
          <Route path="/view-information" element={<ViewInformation />} />
          <Route path="/work-schedule" element={<WorkSchedule />} />
          <Route path="/schedule-modification" element={<ScheduleModification />} />
          <Route path="/annual-leave-modification" element={<AnnualLeaveModification />} />
          <Route path="/recovery-contract" element={<RecoveryContract />} />
          <Route path="/work-contract-modification" element={<WorkContractModification />} />
          <Route path="/batch-application" element={<BatchApplicationOfLaborTemplates />} />

          {/* 12. Calender Note */}
          <Route path="/calender-note" element={<MonthlyView />} />

          {/*13. Schedule Management  */}
          <Route path="/schedule-template" element={<ScheduleTemplate />} />
          <Route path="/add-schedule-template" element={<AddScheduleTemplate />} />

          {/* 14 Checklist Routes */}
          <Route path="/checklist" element={<CheckList />} />
          <Route path="/add-checklist-form" element={<ChecklistForm />} />
          <Route path="/checklist-item" element={<ChecklistItem />} />

          {/* 15. Work a diary */}
          <Route path="/work-a-diary" element={<WorkADiary />} />
          <Route path="/add-new-diary" element={<AddNewDiary />} />
          <Route path="/add-new-diary/:id" element={<AddNewDiary />} />

          {/* Calendar */}
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/calendar-add-event" element={<CalendarAddEvent />} />
          <Route path="/calendar-add-event/:id" element={<CalendarAddEvent />} />

          {/* 17. Payroll Register */}
          <Route path="/payroll-register" element={<PayrollRegister />} />

          {/* 18. Salary Specification */}
          <Route path="/salary-specification" element={<SalarySpecification />} />
          <Route path="/salary-specification-emp-list" element={<EmployeeListForSalarySpecification />} />
          <Route path="/salary-specification-transfer-of-mgt" element={<TransferOfMgt />} />
          <Route path="/salary-detail" element={<DetailPay />} />
          <Route path="/selectedStore/payStatement/authMember" element={<AuthForDetailPay />} />

          {/* 19. Commuting */}
          <Route path="/commuting" element={<Commuting />} />
        </Routes>
        <AlertConfirm />
        <FetchLoading />
      </ErrorBoundary>
    </Wrap>
  );
}

export default App;
